<template>
  <fragment>
    <th colspan="3">
      Postes (total)
    </th>
    <th colspan="3">
      Postes franco.<br/>requis
    </th>
    <th colspan="3">
      Postes franco.<br/>occupés
    </th>
    <th colspan="3">Postes pondérés <small>(équiv. tps plein)</small><br/>
      <small style="font-weight: normal; font-style:italic">(Temps plein x 1.0 + partiel x 0.5 + occassionnel x 0.2)</small>
    </th>
    <th>Différentiels</th>
    <th colspan="3">% Postes francophones pondérés <small>(équiv. tps plein)</small></th>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
  name: 'OnRatiosTableHeaders1',
  components: {
    Fragment
  }
}
</script>